import {BarElement, CategoryScale, Chart as ChartJS, LinearScale, Tooltip} from 'chart.js';
import {FC, StrictMode, useEffect} from 'react';
import {createRoot} from 'react-dom/client';
import styled from 'styled-components';

import {addPrefix, errorAsString} from '@shared/lib/type_utils';

import {CssReset} from '@shared-web/components/core/css_reset';
import {GlobalStyle} from '@shared-web/components/core/global_styles';
import {ViewportWrapper} from '@shared-web/components/core/viewport_wrapper';
import {notifyError} from '@shared-web/lib/notification';
import {ThemeContext} from '@shared-web/theme/theme_context';

import {App} from '@src/components/app';
import {downloadDb, loadDb, setBoysAndGirlsDb, setBoysDb, setGirlsDb} from '@src/lib/db_store';
import {Palette, useThemeData} from '@src/theme';

const Root: FC = () => {
  const themeData = useThemeData();

  useEffect(() => {
    downloadDb()
      .then(db => {
        setBoysDb(loadDb(db, {minRecent: 1, recentYear: 2020, sexes: ['boy']}));
        setGirlsDb(loadDb(db, {minRecent: 1, recentYear: 2020, sexes: ['girl']}));
        setBoysAndGirlsDb(loadDb(db, {minRecent: 1, recentYear: 2020, sexes: ['boy', 'girl']}));
      })
      .catch((err: unknown) =>
        notifyError(err, {
          message: `Échec du téléchargement de la base de données des noms (${errorAsString(err)})`,
        })
      );
  }, []);

  return (
    <ThemeContext.Provider value={themeData}>
      <CssReset />
      {/* <Test></Test> */}
      <ViewportWrapper
        widthOverHeightRatio={{min: 0.4, max: 0.6}}
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        bodyFontSizeRatio={1 / 30}
        backgroundColor={Palette.background2}
      >
        <App />
      </ViewportWrapper>
      <GlobalStyle {...addPrefix(themeData.main, '$')} />
    </ThemeContext.Provider>
  );
};
Root.displayName = 'Root';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <StrictMode>
      <Root />
    </StrictMode>
  );
}
